import React, { useEffect } from "react";
import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  InputNumber,
  Modal,
  Row,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import { useState } from "react";
import { useRef } from "react";
import { FileAttachment } from "../../../../../common/fileAttachment";

import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  checkIfFileTypeIsValidForImageAttachment,
  dateObjToISOFormat,
  readImageFileAsync,
  sanitizeDataTypeClientSide,
} from "../../../../../../utils/utils";
import {
  ArrowLeftOutlined,
  PlusOutlined,
  DeleteOutlined,
  CameraOutlined,
  SearchOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { routes } from "../../../../../../constants";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import TextArea from "antd/es/input/TextArea";
import { getServicesSelectListAction } from "../../../../../../redux/services/services/servicesServices";
import {
  createPackageAction,
  getPackageByIdAction,
  updatePackageAction,
} from "../../../../../../redux/services/packages/packagesServices";
import { fileImageUpload } from "../../../../../../redux/services/auth/authServices";
import Spinner from "../../../../../common/spinner/Spinner";

import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { colors } from "../../../../../../constants/colors";
import { InfoButtonIcon } from "../../../../../../assets/svg";
import { toastService } from "../../../../../common/toast-messages/toast";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import "../OffersAndPackages.scss"

const PackageForm = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const price = form.getFieldValue("price", form);
  const discountedPrice = Form.useWatch("discountedPrice", {
    form,
    preserve: true,
  });
  const discountValue = Form.useWatch("discountValue", {
    form,
    preserve: true,
  });
  const discountType = Form.useWatch("discountType", { form, preserve: true });
  const packageStartDate = Form.useWatch("packageStartDate", {
    form,
    preserve: true,
  });
  const services = Form.useWatch("services", { form, preserve: true });
  const bulletPoints = Form.useWatch("bulletPoints", { form, preserve: true });
  const bulletPoints_ar = Form.useWatch("bulletPoints_ar", {
    form,
    preserve: true,
  });
  /* form dependencies */

  /* id dependencies */
  const { selectedPackageId } = useSelector((state) => state.packages);
  const { servicesSelectList } = useSelector((state) => state.services);
  /* id dependencies */

  /* select list dependencies */
  const [selectedServices, setSelectedServices] = useState([]);
  /* select list dependencies */

  /* module dependencies for attachment - single */
  const [singleAttachmentObj, setSingleAttachmentObj] = useState(null);
  const [singleAttachmetSelectedImageUrl, setSingleAttachmetSelectedImageUrl] =
    useState("");
  /* module dependencies for attachment - single */

  /* module dependencies for attachment */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  const attachmentRef = useRef(null);
  /* module dependencies for attachment */

  /* open image preview for dialog */
  const handleAttachmentPreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await readImageFileAsync(file.originFileObj);
    }
    setPreviewImageSrc(file?.url || file?.preview);
    setOpenPreviewDialog(true);
    const tempPreviewTitle =
      file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
    setPreviewTitle(tempPreviewTitle);
  };
  /* open image preview for dialog */

  /* function definition for select list API calls */
  const selectListApiCalls = (details) => {
    // Categories select list
    const dataToBeSentForServicesSelectList = { page: 1, limit: 500 };
    dispatch(
      getServicesSelectListAction(
        dataToBeSentForServicesSelectList,
        setSelectListLoader
      )
    ).then((apiRes) => {
      const services = apiRes?.data;
      const tempServices =
        details &&
        services &&
        services
          ?.filter((element) => {
            return details?.services?.some(
              (_element) => _element === element._id
            );
          })
          .map((element) => ({
            value: element._id,
            label: element.title,
            price: element.price,
          }));
      tempServices && setSelectedServices(tempServices);
      tempServices && form.setFieldValue("services", tempServices);
    });
  };
  /* function definition for select list API calls */

  useEffect(() => {
    /* load initial dependencies - Edit */
    if (
      selectedPackageId &&
      selectedPackageId !== "" &&
      selectedPackageId !== null &&
      selectedPackageId !== undefined
    ) {
      const dataToBeSent = {
        selectedPackageId,
      };
      dispatch(getPackageByIdAction(dataToBeSent, navigate, setLoading)).then(
        (apiRes) => {
          const tempPackage = apiRes;
          const locale = apiRes.locales[0];
          selectListApiCalls(tempPackage);

          const startDate = dayjs(tempPackage?.packageStartDate);
          const endDate = dayjs(tempPackage?.packageEndDate);
          form.setFieldsValue({
            _id: tempPackage?._id,
            title: tempPackage?.title,
            title_ar: locale.title,
            price: tempPackage?.price,
            discountValue: tempPackage?.discountValue,
            discountedPrice: tempPackage?.discountedPrice,
            discountType: tempPackage?.discountType,
            packageStartDate: startDate || null,
            packageEndDate: endDate || null,
            description_ar: locale?.description,
            description: tempPackage?.description,
            bulletPoints: tempPackage?.bulletPoints,
            bulletPoints_ar: locale?.bulletPoints,
          });
          setAttachmentList(
            tempPackage?.banner?.map((element) => ({
              ...element,
              url: element?.url,
            }))
          );
        }
      );
    } else {
      /* load initial dependencies - Edit */

      /* load initial dependencies - Add */
      selectListApiCalls(null);
    }
    /* load initial dependencies - Add */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* on Services Changed */
  const onServicesChanged = (id, value) => {
    let selectedValueArr = [];
    if (value && value !== undefined && value !== null) {
      selectedValueArr = value;
      let price = selectedValueArr.reduce((accumulator, element) => {
        return accumulator + element.price;
      }, 0);

      form.setFieldValue("price", price);
      packageModuleCalculationsForDiscountPrice(price);
      packageModuleCalculationsForDiscountValue(price);
      setSelectedServices(selectedValueArr);
    }
  };

  const onDeselectServices = (id, value) => {
    let selectedValueObj = null;
    if (value && value !== null && value !== undefined) {
      selectedValueObj = value;
      let price = selectedServices
        ?.filter((element) => element.value !== selectedValueObj.value)
        .reduce((accumulator, element) => {
          return accumulator + element.price;
        }, 0);
      setSelectedServices(
        selectedServices?.filter(
          (element) => element.value !== selectedValueObj.value
        )
      );

      packageModuleCalculationsForDiscountPrice(price);
      packageModuleCalculationsForDiscountValue(price);
    }
  };
  /* on Services Changed */

  /* calculation dependencies */
  const packageModuleCalculationsForDiscountPrice = (price) => {
    let discountValue = form.getFieldValue("discountValue", form);
    const discountType = form.getFieldValue("discountType", form);
    let discountedPrice = form.getFieldValue("discountedPrice", form);

    switch (discountType) {
      case "amount":
        discountedPrice = price - discountValue;
        if (Math.sign(discountedPrice) === -1) {
          form.setFieldValue("discountedPrice", 0);
        } else {
          form.setFieldValue("discountedPrice", discountedPrice.toFixed(2));
        }
        break;
      case "percentage":
        discountedPrice = price - price * (discountValue / 100);
        if (Math.sign(discountedPrice) === -1) {
          form.setFieldValue("discountedPrice", 0);
        } else {
          form.setFieldValue("discountedPrice", discountedPrice.toFixed(2));
        }
        break;
      default:
        return;
    }
  };

  const packageModuleCalculationsForDiscountValue = (price) => {
    let discountValue = form.getFieldValue("discountValue", form);
    const discountType = form.getFieldValue("discountType", form);
    let discountedPrice = form.getFieldValue("discountedPrice", form);
    switch (discountType) {
      case "amount":
        discountValue = price - discountedPrice;
        if (Math.sign(discountValue) === -1) {
          form.setFieldValue("discountValue", 0);
        } else {
          form.setFieldValue("discountValue", discountValue.toFixed(2));
        }
        break;
      case "percentage":
        discountValue = ((price - discountedPrice) / price) * 100;
        if (Math.sign(discountValue) === -1) {
          form.setFieldValue("discountValue", 0);
        } else {
          form.setFieldValue("discountValue", discountValue.toFixed(2));
        }
        break;
      default:
        return;
    }
  };
  /* calculation dependencies */

  /* Form submit handler */
  const onSubmit = (values) => {
    if (selectedServices?.length <= 1) {
      toastService.error(
        t("Modules.Packages.PackagesForm.serviceTooltipMessage")
      );
      return;
    }
    if (!attachmentList || attachmentList?.length === 0) {
      toastService.error(t("pleaseSelectAtleastOneImage"));
      return;
    }
    // data to be sent during create and update

    const dataToBeSent = {
      ...values,
      packageEndDate: dateObjToISOFormat(values?.packageEndDate) || "",
      packageStartDate: dateObjToISOFormat(values?.packageStartDate) || "",
      banner: attachmentList?.map((element) => ({
        name: element?.name,
        url: element?.url,
      })),
      services: selectedServices?.map((element) => element.value),
    };

    if (selectedPackageId) {
      const { isSponsored, ...dataToBeSentForPackage } = dataToBeSent;
      dataToBeSentForPackage._id = selectedPackageId;
      dispatch(
        updatePackageAction(dataToBeSentForPackage, navigate, setLoading)
      );
    } else {
      dispatch(createPackageAction(dataToBeSent, navigate, setLoading));
    }
  };
  /* Form submit handler */

  /* start date and end date validation dependencies */
  const disabledStartDate = (currentDate) => {
    return currentDate && dayjs(currentDate).isBefore(dayjs(), "day");
  };

  const disabledEndDate = (value) => {
    if (!packageStartDate) {
      return true;
    }
    const allowedEndDate = new Date(packageStartDate);
    return value < allowedEndDate.setDate(allowedEndDate.getDate() + 1);
  };
  /* start date and end date validation dependencies */

  return (
    <div className="packageListContainer">
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(baseRouteMaker(routes.PACKAGES))}
          />
          <Title level={2}>{`${
            selectedPackageId
              ? t("Modules.Packages.PackagesForm.editPackage")
              : t("Modules.Packages.PackagesForm.addPackage")
          }`}</Title>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Row justify="start">
            <Col span={12}>
              <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                requiredMark={false}
                style={{ maxWidth: "500px" }}
                onFinish={onSubmit}
              >
                <Flex vertical gap="0.5rem">
                  <Form.Item
                    label={
                      <RequiredLabel
                        text={t("Modules.Packages.PackagesForm.packageName")}
                        required={true}
                      />
                    }
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseEnterPackageName"
                        ),
                      },
                      {
                        whitespace: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseEnterPackageName"
                        ),
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input
                      placeholder={t(
                        "Modules.Packages.PackagesForm.enterPackageName"
                      )}
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <RequiredLabel
                        text={`${t(
                          "Modules.Packages.PackagesForm.packageName"
                        )} ${t("CommonUtils.inArabic")}`}
                        required={true}
                      />
                    }
                    name="title_ar"
                    rules={[
                      {
                        required: true,
                        message: `${t(
                          "Modules.Packages.PackagesForm.pleaseEnterPackageName"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                      {
                        whitespace: true,
                        message: `${t(
                          "Modules.Packages.PackagesForm.pleaseEnterPackageName"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input
                      dir="rtl"
                      placeholder={`${t(
                        "Modules.Packages.PackagesForm.enterPackageName"
                      )} ${t("CommonUtils.inArabic")}`}
                    />
                  </Form.Item>

                  <Form.Item
                    name="services"
                    label={
                      <>
                        <RequiredLabel
                          text={t("Modules.Packages.PackagesForm.services")}
                          required={true}
                        />
                        <Tooltip
                          placement="topLeft"
                          title={t(
                            "Modules.Packages.PackagesForm.serviceTooltipMessage"
                          )}
                          color={colors.DarkMint}
                        >
                          <Button type="text" shape="circle" size="small">
                            <Flex align="center" justify="center">
                              <InfoButtonIcon />
                            </Flex>
                          </Button>
                        </Tooltip>
                      </>
                    }
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseSelectServices"
                        ),
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      options={servicesSelectList}
                      placeholder={t(
                        "Modules.Packages.PackagesForm.selectServices"
                      )}
                      onChange={onServicesChanged}
                      onDeselect={onDeselectServices}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="price"
                    label={
                      <RequiredLabel
                        text={t("Modules.Packages.PackagesForm.price")}
                        required={true}
                      />
                    }
                    rules={[{ required: true, message: "" }]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <InputNumber
                      type="number"
                      style={{ width: "100%" }}
                      controls={false}
                      placeholder={t(
                        "Modules.Packages.PackagesForm.enterPrice"
                      )}
                      disabled
                    />
                  </Form.Item>

                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item
                        name="discountType"
                        label={
                          <RequiredLabel
                            text={t("Modules.Offer.OfferForm.discountType")}
                            required={true}
                          />
                        }
                        rules={[
                          {
                            required: true,
                            message: t(
                              "Modules.Offer.OfferForm.pleaseSelectDiscountType"
                            ),
                          },
                        ]}
                      >
                        <Select
                          loading={selectListLoader}
                          options={[
                            { value: "amount", label: "Amount" },
                            { value: "percentage", label: "Percentage" },
                          ]}
                          placeholder={t(
                            "Modules.Offer.OfferForm.selectDiscountType"
                          )}
                          onChange={() =>
                            form.resetFields([
                              "discountValue",
                              "discountedPrice",
                            ])
                          }
                          onKeyUp={() =>
                            packageModuleCalculationsForDiscountPrice(price)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        name="discountValue"
                        label={
                          <RequiredLabel
                            text={
                              discountType === "amount"
                                ? t("Modules.Offer.OfferForm.discountValue")
                                : discountType === "percentage"
                                ? t("Modules.Offer.OfferForm.discountPercent")
                                : t("Modules.Offer.OfferForm.discountValue")
                            }
                            required={true}
                          />
                        }
                        rules={[
                          {
                            required: true,
                            message:
                              discountType === "amount"
                                ? t(
                                    "Modules.Offer.OfferForm.pleaseEnterDiscountValue"
                                  )
                                : discountType === "percentage"
                                ? t(
                                    "Modules.Offer.OfferForm.pleaseEnterDiscountPercent"
                                  )
                                : t(
                                    "Modules.Offer.OfferForm.pleaseEnterDiscountValue"
                                  ),
                          },
                          {
                            validator: (_, value) => {
                              if (discountType === "percentage") {
                                if (value && Number(value) > 100) {
                                  return Promise.reject(
                                    `${t(
                                      "Modules.Offer.OfferForm.discountPercent"
                                    )} ${t(
                                      "CommonUtils.shouldNotBeGreaterThan10"
                                    )}`
                                  );
                                } else if (value && Number(value) < 1) {
                                  return Promise.reject(
                                    `${t(
                                      "Modules.Offer.OfferForm.discountPercent"
                                    )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                                  );
                                }
                              } else if (discountType === "amount") {
                                if (value && Number(value) > Number(price)) {
                                  return Promise.reject(
                                    `${t(
                                      "Modules.Offer.OfferForm.discountValue"
                                    )} ${t(
                                      "CommonUtils.cannotBeGreaterThan"
                                    )} ${t(
                                      "Modules.Packages.PackagesForm.price"
                                    )}`
                                  );
                                } else if (value && Number(value) < 1) {
                                  return Promise.reject(
                                    `${t(
                                      "Modules.Offer.OfferForm.discountValue"
                                    )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                                  );
                                }
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          placeholder={
                            discountType === "amount"
                              ? t("Modules.Offer.OfferForm.enterDiscountValue")
                              : discountType === "percentage"
                              ? t(
                                  "Modules.Offer.OfferForm.enterDiscountPercent"
                                )
                              : t("Modules.Offer.OfferForm.enterDiscountValue")
                          }
                          onKeyUp={() => {
                            packageModuleCalculationsForDiscountPrice(price);
                            if (
                              discountValue?.length > 10 ||
                              discountedPrice < 0 ||
                              !discountValue
                            )
                              form.setFieldValue("discountedPrice", 0);
                            if (
                              discountType === "percentage" &&
                              discountValue > 100
                            )
                              form.setFieldValue("discountedPrice", 0);
                            if (
                              discountType === "amount" &&
                              discountValue > price
                            )
                              form.setFieldValue("discountedPrice", 0);
                          }}
                          disabled={services?.length === 0 || !discountType}
                          onKeyDown={(e) =>
                            allowCharactersOnlyForDecimalNumbers(e)
                          }
                          onWheel={(e) => e.currentTarget.blur()}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="discountedPrice"
                    label={
                      <RequiredLabel
                        text={t(
                          "Modules.Packages.PackagesForm.discountedPrice"
                        )}
                        required={true}
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseEnterDiscountedPrice"
                        ),
                      },
                      {
                        validator: async (_, value) => {
                          const price = form.getFieldValue("price", form);
                          if (value && Number(value) > Number(price)) {
                            return Promise.reject(
                              `${t(
                                "Modules.Packages.PackagesForm.discountedPrice"
                              )} ${t("CommonUtils.cannotBeGreaterThan")} ${t(
                                "Modules.Packages.PackagesForm.price"
                              )}`
                            );
                          } else if (value && Number(value) < 1) {
                            return Promise.reject(
                              `${t(
                                "Modules.Packages.PackagesForm.discountedPrice"
                              )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t(
                        "Modules.Packages.PackagesForm.enterPrice"
                      )}
                      onKeyUp={() => {
                        const price = form.getFieldValue("price", form);
                        packageModuleCalculationsForDiscountValue(price);
                        (discountedPrice?.length > 10 ||
                          discountValue < 0 ||
                          discountedPrice > price ||
                          !discountedPrice) &&
                          form.setFieldValue("discountValue", 0);
                      }}
                      disabled={services?.length === 0}
                      onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                      onWheel={(e) => e.currentTarget.blur()}
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <RequiredLabel
                        text={t(
                          "Modules.Packages.PackagesForm.packageStartDate"
                        )}
                        required={true}
                      />
                    }
                    name="packageStartDate"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseSelectPackageStartDate"
                        ),
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", cursor: "pointer" }}
                      placeholder={t(
                        "Modules.Packages.PackagesForm.selectPackageStartDate"
                      )}
                      disabledDate={disabledStartDate}
                      onChange={() =>
                        form.setFieldValue("packageEndDate", null)
                      }
                      onKeyDown={(event) => event.preventDefault()}
                      format={"DD-MM-YYYY"}
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <RequiredLabel
                        text={t("Modules.Packages.PackagesForm.packageEndDate")}
                        required={true}
                      />
                    }
                    name="packageEndDate"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseSelectPackageEndDate"
                        ),
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", cursor: "pointer" }}
                      placeholder={t(
                        "Modules.Packages.PackagesForm.selectPackageEndDate"
                      )}
                      disabledDate={disabledEndDate}
                      onKeyDown={(event) => event.preventDefault()}
                      format={"DD-MM-YYYY"}
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <RequiredLabel
                        text={t("Modules.Packages.PackagesForm.description")}
                        required={true}
                      />
                    }
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseEnterDescription"
                        ),
                      },
                      {
                        whitespace: true,
                        message: t(
                          "Modules.Packages.PackagesForm.pleaseEnterDescription"
                        ),
                      },
                    ]}
                    // normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <TextArea
                      rows={4}
                      showCount
                      maxLength={
                        appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                      }
                      placeholder={t(
                        "CommonUtils.enterDescriptionUpto255Characters"
                      )}
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <RequiredLabel
                        text={`${t(
                          "Modules.Packages.PackagesForm.description"
                        )} ${t("CommonUtils.inArabic")}`}
                        required={true}
                      />
                    }
                    name="description_ar"
                    rules={[
                      {
                        required: true,
                        message: `${t(
                          "Modules.Packages.PackagesForm.pleaseEnterDescription"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                      {
                        whitespace: true,
                        message: `${t(
                          "Modules.Packages.PackagesForm.pleaseEnterDescription"
                        )} ${t("CommonUtils.inArabic")}`,
                      },
                    ]}
                    // normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <TextArea
                      dir="rtl"
                      rows={4}
                      showCount
                      maxLength={
                        appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                      }
                      placeholder={`${t(
                        "CommonUtils.enterDescriptionUpto255Characters"
                      )} ${t("CommonUtils.inArabic")}`}
                    />
                  </Form.Item>

                  {/* form multiple list - bulletPoints */}
                  <Form.List name="bulletPoints">
                    {(fields, { add, remove }) => (
                      <>
                        <Form.Item>
                          <Flex justify="space-between">
                            <Title level={3}>Add Key Points</Title>
                            <Button
                              type="primary"
                              shape="circle"
                              size="small"
                              disabled={bulletPoints?.length >= 5}
                              icon={<PlusOutlined />}
                              onClick={() => add()}
                            />
                          </Flex>
                        </Form.Item>
                        <div
                          style={{
                            display: "flex",
                            rowGap: 16,
                            flexDirection: "column",
                          }}
                        >
                          {fields.map(({ key, name, ...restField }) => (
                            <Card
                              size="small"
                              title={`Key Point ${name + 1}`}
                              key={key}
                              extra={
                                <Button
                                  type="default"
                                  shape="circle"
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  onClick={() => remove(name)}
                                />
                              }
                            >
                              <Form.Item {...restField} name={[name]}>
                                <Input />
                              </Form.Item>
                            </Card>
                          ))}
                        </div>
                      </>
                    )}
                  </Form.List>
                  {/* form multiple list - bulletPoints */}

                  {/* form multiple list - bulletPoints_ar */}
                  <Form.List name="bulletPoints_ar">
                    {(fields, { add, remove }) => (
                      <>
                        <Form.Item>
                          <Flex justify="space-between">
                            <Title level={3}>{`${t("keyPoints")} ${t(
                              "CommonUtils.inArabic"
                            )}`}</Title>
                            <Button
                              type="primary"
                              shape="circle"
                              size="small"
                              disabled={bulletPoints_ar?.length >= 5}
                              icon={<PlusOutlined />}
                              onClick={() => add()}
                            />
                          </Flex>
                        </Form.Item>
                        <div
                          style={{
                            display: "flex",
                            rowGap: 16,
                            flexDirection: "column",
                          }}
                        >
                          {fields.map(({ key, name, ...restField }) => (
                            <Card
                              size="small"
                              title={`Key Point ${name + 1} ${t(
                                "CommonUtils.inArabic"
                              )}`}
                              key={key}
                              extra={
                                <Button
                                  type="default"
                                  shape="circle"
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  onClick={() => remove(name)}
                                />
                              }
                            >
                              <Form.Item {...restField} name={[name]}>
                                <Input dir="rtl" />
                              </Form.Item>
                            </Card>
                          ))}
                        </div>
                      </>
                    )}
                  </Form.List>
                  {/* form multiple list - bulletPoints_ar */}

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={loading}
                    disabled={loading}
                  >
                    {`${
                      selectedPackageId
                        ? t("Modules.Packages.PackagesForm.editPackage")
                        : t("Modules.Packages.PackagesForm.addPackage")
                    }`}
                  </Button>
                </Flex>
              </Form>
            </Col>
            <Col span={7}>
            <Typography.Title level={4} style={{ marginBottom: 10 }}>
              <Flex gap="0.2rem" align="center">
                <RequiredLabel text={t("UploadImages")} required={true} />
                <Tooltip
                  placement="topLeft"
                  title={t("CommonUtils.multipleImagesTooltip")}
                  color={colors.DarkMint}
                >
                  <Button type="text" shape="circle" size="small">
                    <Flex align="center" justify="center">
                      <InfoButtonIcon />
                    </Flex>
                  </Button>
                </Tooltip>
              </Flex>
            </Typography.Title>
            <Flex
              style={{ flexDirection: "column-reverse", textAlign: "center" }}
            >
              <Flex vertical gap="0.5rem">
                <div
                  className="attachmentContainer"
                  style={{ cursor: "pointer" }}
                  onClick={() => attachmentRef.current?.click()}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<PlusOutlined style={{ fontSize: "22px" }} />}
                  />
                </div>
                <Flex
                  vertical
                  style={{ width: "385px" }}
                  align="center"
                  justify="center"
                >
                  <Typography.Title level={3} type="secondary">
                    {t("CommonUtils.supportedImageFormats")}
                  </Typography.Title>

                  <Typography.Title
                    level={3}
                    type="secondary"
                    style={{ margin: 5 }}
                  >
                    {t("CommonUtils.maxImage")}
                  </Typography.Title>

                  <Typography.Title
                    level={3}
                    type="success"
                    style={{ margin: 0, textAlign: "center" }}
                  >
                    {t("CommonUtils.addImagesInParticular")}
                    <br />
                    {t("CommonUtils.dimension1")}
                    <br />
                    {t("CommonUtils.or")}
                    <br />
                    {t("CommonUtils.dimension2")}
                    <br />
                  </Typography.Title>
                </Flex>
              </Flex>
              <Flex vertical align="center" justify="center">
                <Upload
                  listType="picture-card"
                  fileList={attachmentList}
                  multiple
                  accept="image/*"
                  onPreview={handleAttachmentPreview}
                  onChange={(options) => {
                    const tempFileTypeIsValidResArr = options?.fileList?.map(
                      (element) =>
                        checkIfFileTypeIsValidForImageAttachment(element.name)
                    );

                    const isValid = !tempFileTypeIsValidResArr?.some(
                      (element) => element.isValid === false
                    );
                    const fileTypeIsValidRes = tempFileTypeIsValidResArr?.find(
                      (element) => element.isValid === false
                    );

                    if (isValid === false) {
                      toastService.error(fileTypeIsValidRes.isInvalidMessage);
                    } else {
                      setAttachmentList(options.fileList);
                    }
                  }}
                  onRemove={(file) =>
                    setAttachmentList(
                      attachmentList.filter(
                        (element) => element.uid !== file.uid
                      )
                    )
                  }
                  customRequest={(options) => {
                    console.log(options, "options");
                    const attachmentFileName = options.file.name;
                    const fileTypeIsValidRes =
                      checkIfFileTypeIsValidForImageAttachment(
                        attachmentFileName
                      );

                    if (fileTypeIsValidRes.isValid === false) {
                      toastService.error(fileTypeIsValidRes.isInvalidMessage);
                      return;
                    } else {
                      const formData = new FormData();
                      formData.append("image", options.file);
                      dispatch(fileImageUpload(formData)).then((apiRes) => {
                        const imageUrl = apiRes?.[0];
                        options.file["url"] = imageUrl;
                        options.onSuccess(imageUrl, options.file);
                      });
                    }
                  }}
                  className="uploadContainer"
                >
                  <div ref={attachmentRef}></div>
                </Upload>
                <Modal
                  open={openPreviewDialog}
                  title={previewTitle}
                  footer={null}
                  onCancel={() => setOpenPreviewDialog(false)}
                >
                  <img style={{ width: "100%" }} src={previewImageSrc} />
                </Modal>
              </Flex>
            </Flex>
          </Col>
          </Row>
        )}
      </Flex>
    </div>
  );
};

export default PackageForm;
